import Vue from "vue";
import { Auth0Plugin } from "./auth0-plugin";

Vue.use(Auth0Plugin, {
    domain: process.env.AUTH0.domain,
    clientId: process.env.AUTH0.client_id,
    redirectUri: `${window.location.origin}/callback`,
    audience: process.env.AUTH0.audience,
    responseType: 'token id_token',
    scope: 'openid profile email', // define the scopes you want to use
    useRefreshTokens: true,
    cacheLocation: 'localstorage',
    onRedirectCallback: appState => {
      router.push(
        appState && appState.targetUrl
          ? appState.targetUrl
          : window.location.pathname
      );
    }
  });